import { HotelRelinkingBlock } from './HotelRelinkingBlock';

export default HotelRelinkingBlock;
